import { render, staticRenderFns } from "./IndividualPopup.vue?vue&type=template&id=48539005"
import script from "./individual-popup.ts?vue&type=script&lang=ts&external"
export * from "./individual-popup.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports